/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  PriceProvidersRepository,
  PriceProvidersRepositoryInterface,
} from "../PriceProvidersRepository";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_quoteToken",
        type: "address",
      },
      {
        internalType: "address",
        name: "_siloRepository",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "AssetNotSupported",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidPriceProvider",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidPriceProviderQuoteToken",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidRepository",
    type: "error",
  },
  {
    inputs: [],
    name: "ManagerDidNotChange",
    type: "error",
  },
  {
    inputs: [],
    name: "ManagerIsZero",
    type: "error",
  },
  {
    inputs: [],
    name: "OnlyManager",
    type: "error",
  },
  {
    inputs: [],
    name: "OnlyOwnerOrManager",
    type: "error",
  },
  {
    inputs: [],
    name: "OnlyRepository",
    type: "error",
  },
  {
    inputs: [],
    name: "PriceProviderAlreadyExists",
    type: "error",
  },
  {
    inputs: [],
    name: "PriceProviderDoesNotExist",
    type: "error",
  },
  {
    inputs: [],
    name: "PriceProviderNotRegistered",
    type: "error",
  },
  {
    inputs: [],
    name: "QuoteTokenNotSupported",
    type: "error",
  },
  {
    inputs: [],
    name: "TokenIsNotAContract",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "manager",
        type: "address",
      },
    ],
    name: "ManagerChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "contract IPriceProvider",
        name: "newPriceProvider",
        type: "address",
      },
    ],
    name: "NewPriceProvider",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "newPendingOwner",
        type: "address",
      },
    ],
    name: "OwnershipPending",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "asset",
        type: "address",
      },
      {
        indexed: true,
        internalType: "contract IPriceProvider",
        name: "priceProvider",
        type: "address",
      },
    ],
    name: "PriceProviderForAsset",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "contract IPriceProvider",
        name: "priceProvider",
        type: "address",
      },
    ],
    name: "PriceProviderRemoved",
    type: "event",
  },
  {
    inputs: [],
    name: "QUOTE_TOKEN_DECIMALS",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "acceptOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IPriceProvider",
        name: "_provider",
        type: "address",
      },
    ],
    name: "addPriceProvider",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_manager",
        type: "address",
      },
    ],
    name: "changeManager",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "getPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IPriceProvider",
        name: "_provider",
        type: "address",
      },
    ],
    name: "isPriceProvider",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "manager",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pendingOwner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "priceProviders",
    outputs: [
      {
        internalType: "contract IPriceProvider",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "priceProvidersRepositoryPing",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "providerList",
    outputs: [
      {
        internalType: "address[]",
        name: "",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "providersCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "providersReadyForAsset",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "quoteToken",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "removePendingOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IPriceProvider",
        name: "_provider",
        type: "address",
      },
    ],
    name: "removePriceProvider",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "contract IPriceProvider",
        name: "_provider",
        type: "address",
      },
    ],
    name: "setPriceProviderForAsset",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "siloRepository",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newPendingOwner",
        type: "address",
      },
    ],
    name: "transferPendingOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type PriceProvidersRepositoryConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: PriceProvidersRepositoryConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class PriceProvidersRepository__factory extends ContractFactory {
  constructor(...args: PriceProvidersRepositoryConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "PriceProvidersRepository";
  }

  deploy(
    _quoteToken: string,
    _siloRepository: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<PriceProvidersRepository> {
    return super.deploy(
      _quoteToken,
      _siloRepository,
      overrides || {}
    ) as Promise<PriceProvidersRepository>;
  }
  getDeployTransaction(
    _quoteToken: string,
    _siloRepository: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _quoteToken,
      _siloRepository,
      overrides || {}
    );
  }
  attach(address: string): PriceProvidersRepository {
    return super.attach(address) as PriceProvidersRepository;
  }
  connect(signer: Signer): PriceProvidersRepository__factory {
    return super.connect(signer) as PriceProvidersRepository__factory;
  }
  static readonly contractName: "PriceProvidersRepository";
  public readonly contractName: "PriceProvidersRepository";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): PriceProvidersRepositoryInterface {
    return new utils.Interface(_abi) as PriceProvidersRepositoryInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): PriceProvidersRepository {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as PriceProvidersRepository;
  }
}
